import { defineComponent as _defineComponent } from 'vue'
import mapboxgl from 'mapbox-gl'
import { computed } from 'vue'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { resourcePinStyle } from './styles/resource-pin'
import { useResourcesGeoJSON } from '@/components/field-view-next/composables/useResourcesGeoJSON'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesLayer',
  props: {
    layerId: null,
    sourceId: null,
    hiddenFeatureIds: null,
    before: null,
    hideLayer: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (
    event: 'click',
    data: mapboxgl.MapboxGeoJSONFeature[],
    eventData: mapboxgl.MapMouseEvent & mapboxgl.EventData
  )
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  layerId: string
  sourceId: string
  hiddenFeatureIds?: (number | string)[]
  before?: string
  hideLayer?: boolean
}




const handleClick = (
  data: mapboxgl.MapboxGeoJSONFeature[],
  eventData: mapboxgl.MapMouseEvent & mapboxgl.EventData
) => {
  emits('click', data, eventData)
}

const layers: mapboxgl.SymbolLayer[] = [
  {
    id: props.layerId,
    type: 'symbol',
    layout: {
      ...resourcePinStyle.layout,
    },
    paint: {
      ...resourcePinStyle.paint,
    },
  },
]

const { data: geoJsonData } = useResourcesGeoJSON()

// Provide a fallback for when data is undefined
const safeGeoJsonData = computed(
  () => geoJsonData.value || { type: 'FeatureCollection', features: [] }
)

const filter = computed(() => {
  const filterArray: any[] = ['all']
  const ids = props.hiddenFeatureIds || []
  if (ids.length > 0) {
    filterArray.push(['!', ['in', ['id'], ['literal', ids]]])
  }
  return filterArray
})

return { __sfc: true,props, emits, handleClick, layers, geoJsonData, safeGeoJsonData, filter, GeoJsonSource, LayerGroup }
}

})